import { BookImage, Text } from '@fable/components'
import { useTheme } from '@fable/theme'
import { Book } from '@fable/types'

interface Props {
  book: Book
  customClass?: string
  onSelect: () => void
  altTag: string
}

export const FolioBook: React.FC<Props> = ({
  book,
  customClass = '',
  onSelect,
  altTag,
}) => {
  const { colors } = useTheme()
  const { title, authors, cover_image_small } = book

  return (
    <div
      className={`${customClass} folio`}
      data-testid="folio-book-component"
      onClick={onSelect}
    >
      <BookImage image={cover_image_small} altTag={altTag} />
      <div className="book-details">
        <Text
          tag="p"
          className="book-title"
          type="subhead"
          sizing={{ base: 'XS', mobileL: 'S' }}
        >
          {title}
        </Text>
        <Text
          className="book-author"
          type="body"
          sizing={{ base: 'S', mobileL: 'M' }}
          color={colors.hurricane}
        >
          {authors[0]?.name}
        </Text>
      </div>
    </div>
  )
}
